import script from "./sideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./sideBar.vue?vue&type=script&setup=true&lang=js"

import "./sideBar.vue?vue&type=style&index=0&id=4e08cf3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_59e517ed8ea5909a7bfb8c19836a23be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e08cf3f"]])

export default __exports__